import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatAutocomplete, MatAutocompleteSelectedEvent, MatChipInputEvent, MatDialogRef, MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Content, Generic } from '../../models';
import { ContentService } from '../../services';

export class NodeStat {
  public children: NodeStat[];
  public name: string;
  public id: number;
  public path: string;
  public size: number;
  public type: string;
}

@Component({
  selector: 'convert-to-structured',
  templateUrl: './convert-to-structured.dialog.html',
  encapsulation: ViewEncapsulation.None,
})
export class ConvertToStructuredDialog implements OnInit {
  public name: string;
  /* Chips Autocomplete */
  public nodes: Observable<any>;
  public allDirs: NodeStat[];
  public selected: string[];
  public autoCompleteCtrl: FormControl;
  public separatorKeysCodes: number[] = [13];
  @ViewChild('foldersInput') public foldersInput: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<ConvertToStructuredDialog>,
    private contentService: ContentService,
    private router: Router,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: Content) {
  }
  public ngOnInit(): void {
    this.name = 'Structured ' + this.data.name;
    this.selected = [];
    this.autoCompleteCtrl = new FormControl('');
    this.contentService.getContentNodes(this.data._id).subscribe((rootNode) => {
      this.allDirs = this.getChildrenDirs(rootNode.children);
      console.log(this.allDirs);
      this.nodes = this.autoCompleteCtrl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || '')),
      );
    });
  }
  public onNoClick = () => { this.dialogRef.close(); };

  public onSubmit() {
    const paths = this.selected;
    const name = this.name;
    this.contentService.convertToStructured(this.data._id, { name, paths }).subscribe((res) => {
      this.toastr.success("Converted successfully")
      this.router.navigate(['/contents/' + res._id + '/details'])
      //.then(() => { window.location.reload(); });
      this.dialogRef.close();
    });
  }

  public onRemovePath(path: NodeStat): void {
    const index = this.selected.findIndex((path) => path == path);
    if (index >= 0) {
      this.selected.splice(index, 1);
    }
  }
  public onSelectedPath(event: MatAutocompleteSelectedEvent): void {
    const path = event.option.value;
    if (!this.allDirs.find((n) => n.path == path)) { return; }
    this.selected.push(path);
    // this.foldersInput.nativeElement.value = '';
    this.autoCompleteCtrl.setValue('');
    this.autoCompleteCtrl.updateValueAndValidity();
  }
  private _filter(value: string): NodeStat[] {
    const filterValue = value.toLowerCase();
    // exclude already selected options and their children
    console.log('exlude selected and children', this.allDirs.filter((n) => !this.selected.find((s) => s.startsWith(n.path))).length);
    return this.allDirs
      .filter((node) => !this.selected.find((s) => node.path.startsWith(s)))
      .filter((node) => node.path.toLowerCase().includes(filterValue))
      .sort((a, b) => (a.path.length - b.path.length));
  }
  private getChildrenDirs(xs: NodeStat[]) {
    return xs.reduce((acc, x) => {
      if (x.type != 'directory') { return acc; }
      acc = acc.concat(x);
      if (x.children) {
        acc = acc.concat(this.getChildrenDirs(x.children));
        x.children = [];
      }
      return acc;
    }, []);
  }
}
